/* global cast */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Chromecast = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.tag.getEstimatedTime || this.tag.currentTime
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.tag.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    try {
      if (this.player.getStreamingProtocol) {
        var protocol = this.player.getStreamingProtocol()
        for (var c = 0; c < protocol.getStreamCount(); c++) {
          var streamInfo = protocol.getStreamInfo(c)
          if (streamInfo.mimeType.indexOf('video/') === 0) {
            var videoLevel = protocol.getQualityLevel(c)
            if (streamInfo.bitrates && streamInfo.bitrates[videoLevel]) {
              return streamInfo.bitrates[videoLevel]
            }
          }
        }
      }
      return null // No video stream available
    } catch (err) {
      return null // Stream info not available yet, do nothing
    }
  },

  /** Override to return rendition */
  getRendition: function () {
    if (this.player && this.player.videoHeight && this.player.videoWidth) {
      return youbora.Util.buildRenditionString(this.player.videoWidth, this.player.videoHeight, this.getBitrate())
    }
    return null
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (!this.tag.currentSrc.startsWith('blob:')) {
      return this.tag.currentSrc
    } else if (this.player) {
      return this.player.getHost().url
    } else {
      return 'unknown'
    }
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return this.player ? this.player.playbackRate : null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player ? this.player.webkitDroppedFrameCount : null
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    if (cast && cast.player && cast.player.api) {
      return cast.player.api.VERSION
    }
    return null
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Chromecast'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    this.tag = document.getElementsByTagName('video')[0]

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false, 1200)

    // Register listeners
    this.references = {}
    this.references['loadstart'] = this.playListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['playing'] = this.playingListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['seeking'] = this.seekingListener.bind(this)
    this.references['abort'] = this.endedListener.bind(this)
    this.references['ended'] = this.endedListener.bind(this)
    this.references['buffering'] = this.bufferingListener.bind(this)

    this.hostReferences = {}
    this.hostReferences['onAutoPause'] = this.autoPauseListener.bind(this)

    for (var key in this.references) {
      this.tag.addEventListener(key, this.references[key])
    }
    if (cast && cast.player && cast.player.api && cast.player.api.Player &&
      cast.player.api.Player.getHost && cast.player.api.Player.getHost()) {
      for (var key2 in this.hostReferences) {
        cast.player.api.Player.getHost().addEventListener(key2, this.hostReferences[key2])
      }
    }
  },

  /** Unregister listeners to this.tag. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.tag && this.references) {
      if (typeof this.tag.removeEventListener === 'function') {
        for (var key in this.references) {
          this.tag.removeEventListener(key, this.references[key])
        }
      }
      this.references = {}
    }
    if (cast && cast.player && cast.player.api && cast.player.api.Player && cast.player.api.Player.getHost() && this.hostReferences) {
      for (var key2 in this.hostReferences) {
        this.player.getHost().removeEventListener(key2, this.hostReferences[key2])
      }
      this.hostReferences = {}
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    if (!this.flags.isBuffering) {
      this.firePause()
    }
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) { // ?
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e)
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'buffering' event. */
  bufferingListener: function (e) {
    if (this.flags.isPaused) {
      this.fireResume()
    }
    this.fireBufferBegin()
  },

  autoPauseListener: function (e) {
    if (e) {
      this.fireResume()
      this.fireBufferBegin()
    } else {
      this.fireBufferEnd()
    }
  }
})

module.exports = youbora.adapters.Chromecast
